import React from 'react';
import { Sparkles, Shield, Share2 } from 'lucide-react';
import { PageSection } from '../../../../types';

interface FooterEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const FooterEditor: React.FC<FooterEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};

  return (
    <div className="space-y-6">
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">Footer Metinleri</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Footer Açıklama / Slogan</label>
          <textarea
            value={content.description ?? ''}
            onChange={(e) => onUpdateContent({ description: e.target.value })}
            rows={3}
            placeholder="Şirket hakkında kısa özet ve vizyon..."
            className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 p-2.5 rounded-xl outline-none focus:border-blue-500 resize-none"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Telif Hakkı (Copyright) Metni</label>
          <input
            type="text"
            value={content.copyright ?? `© ${new Date().getFullYear()} Tüm Hakları Saklıdır.`}
            onChange={(e) => onUpdateContent({ copyright: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};
